import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ConsoleApiName } from '../../tools/display';
import { NO_ERROR_STACK_PRESENT_MESSAGE, isError } from '../error/error';
import { toStackTraceString } from '../../tools/stackTrace/handlingStack';
import { getExperimentalFeatures } from '../../tools/experimentalFeatures';
import { INTAKE_SITE_STAGING, INTAKE_SITE_US1_FED } from '../intakeSites';
import { Observable } from '../../tools/observable';
import { timeStampNow } from '../../tools/utils/timeUtils';
import { displayIfDebugEnabled, startMonitorErrorCollection } from '../../tools/monitor';
import { sendToExtension } from '../../tools/sendToExtension';
import { performDraw } from '../../tools/utils/numberUtils';
import { jsonStringify } from '../../tools/serialisation/jsonStringify';
import { combine } from '../../tools/mergeInto';
import { computeStackTrace } from '../../tools/stackTrace/computeStackTrace';
import { getConnectivity } from '../connectivity';
import { createBoundedBuffer } from '../../tools/boundedBuffer';
import { canUseEventBridge, getEventBridge, startBatchWithReplica } from '../../transport';
import { TelemetryType } from './rawTelemetryEvent.types';
var ALLOWED_FRAME_URLS = ['https://www.datadoghq-browser-agent.com', 'https://www.datad0g-browser-agent.com', 'https://d3uc069fcn7uxw.cloudfront.net', 'https://d20xtzwzcl0ceb.cloudfront.net', 'http://localhost', '<anonymous>'];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
// eslint-disable-next-line local-rules/disallow-side-effects
var preStartTelemetryBuffer = createBoundedBuffer();
var _onRawTelemetryEventCollected2 = function onRawTelemetryEventCollected(event) {
  preStartTelemetryBuffer.add(function () {
    return _onRawTelemetryEventCollected2(event);
  });
};
export function startTelemetry(telemetryService, configuration, reportError, pageMayExitObservable, createEncoder) {
  var observable = new Observable();
  var _startTelemetryTransp = startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, observable),
    stop = _startTelemetryTransp.stop;
  var _startTelemetryCollec = startTelemetryCollection(telemetryService, configuration, observable),
    enabled = _startTelemetryCollec.enabled,
    setContextProvider = _startTelemetryCollec.setContextProvider;
  return {
    setContextProvider: setContextProvider,
    stop: stop,
    enabled: enabled
  };
}
export function startTelemetryCollection(telemetryService, configuration, observable) {
  var alreadySentEvents = new Set();
  var contextProviders = new Map();
  var telemetryEnabled = !TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && performDraw(configuration.telemetrySampleRate);
  var telemetryEnabledPerType = _defineProperty(_defineProperty(_defineProperty({}, TelemetryType.LOG, telemetryEnabled), TelemetryType.CONFIGURATION, telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate)), TelemetryType.USAGE, telemetryEnabled && performDraw(configuration.telemetryUsageSampleRate));
  var runtimeEnvInfo = getRuntimeEnvInfo();
  _onRawTelemetryEventCollected2 = function _onRawTelemetryEventCollected(rawEvent) {
    var stringifiedEvent = jsonStringify(rawEvent);
    if (telemetryEnabledPerType[rawEvent.type] && alreadySentEvents.size < configuration.maxTelemetryEventsPerPage && !alreadySentEvents.has(stringifiedEvent)) {
      var event = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
      observable.notify(event);
      sendToExtension('telemetry', event);
      alreadySentEvents.add(stringifiedEvent);
    }
  };
  // need to be called after telemetry context is provided and observers are registered
  preStartTelemetryBuffer.drain();
  startMonitorErrorCollection(addTelemetryError);
  return {
    setContextProvider: function setContextProvider(key, contextProvider) {
      return contextProviders.set(key, contextProvider);
    },
    enabled: telemetryEnabled
  };
  function toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo) {
    var event = {
      type: 'telemetry',
      date: timeStampNow(),
      service: telemetryService,
      version: "6.13.0",
      source: 'browser',
      _dd: {
        format_version: 2
      },
      telemetry: combine(rawEvent, {
        runtime_env: runtimeEnvInfo,
        connectivity: getConnectivity(),
        sdk_setup: "npm"
      }),
      experimental_features: Array.from(getExperimentalFeatures())
    };
    var _iterator = _createForOfIteratorHelper(contextProviders),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          contextProvider = _step$value[1];
        event[key] = contextProvider();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return event;
  }
}
function startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, telemetryObservable) {
  var cleanupTasks = [];
  if (canUseEventBridge()) {
    var bridge = getEventBridge();
    var telemetrySubscription = telemetryObservable.subscribe(function (event) {
      return bridge.send('internal_telemetry', event);
    });
    cleanupTasks.push(function () {
      return telemetrySubscription.unsubscribe();
    });
  } else {
    var telemetryBatch = startBatchWithReplica(configuration, {
      endpoint: configuration.rumEndpointBuilder,
      encoder: createEncoder(4 /* DeflateEncoderStreamId.TELEMETRY */)
    }, configuration.replica && {
      endpoint: configuration.replica.rumEndpointBuilder,
      encoder: createEncoder(5 /* DeflateEncoderStreamId.TELEMETRY_REPLICA */)
    }, reportError, pageMayExitObservable,
    // We don't use an actual session expire observable here, to make telemetry collection
    // independent of the session. This allows to start and send telemetry events ealier.
    new Observable());
    cleanupTasks.push(function () {
      return telemetryBatch.stop();
    });
    var _telemetrySubscription = telemetryObservable.subscribe(function (event) {
      return telemetryBatch.add(event, isTelemetryReplicationAllowed(configuration));
    });
    cleanupTasks.push(function () {
      return _telemetrySubscription.unsubscribe();
    });
  }
  return {
    stop: function stop() {
      return cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}
function getRuntimeEnvInfo() {
  return {
    is_local_file: window.location.protocol === 'file:',
    is_worker: 'WorkerGlobalScope' in self
  };
}
export function startFakeTelemetry() {
  var events = [];
  _onRawTelemetryEventCollected2 = function _onRawTelemetryEventCollected(event) {
    events.push(event);
  };
  return events;
}
export function resetTelemetry() {
  preStartTelemetryBuffer = createBoundedBuffer();
  _onRawTelemetryEventCollected2 = function _onRawTelemetryEventCollected(event) {
    preStartTelemetryBuffer.add(function () {
      return _onRawTelemetryEventCollected2(event);
    });
  };
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
export function isTelemetryReplicationAllowed(configuration) {
  return configuration.site === INTAKE_SITE_STAGING;
}
export function addTelemetryDebug(message, context) {
  displayIfDebugEnabled(ConsoleApiName.debug, message, context);
  _onRawTelemetryEventCollected2(_objectSpread({
    type: TelemetryType.LOG,
    message: message,
    status: "debug" /* StatusType.debug */
  }, context));
}
export function addTelemetryError(e, context) {
  _onRawTelemetryEventCollected2(_objectSpread(_objectSpread({
    type: TelemetryType.LOG,
    status: "error" /* StatusType.error */
  }, formatError(e)), context));
}
export function addTelemetryConfiguration(configuration) {
  _onRawTelemetryEventCollected2({
    type: TelemetryType.CONFIGURATION,
    configuration: configuration
  });
}
export function addTelemetryUsage(usage) {
  _onRawTelemetryEventCollected2({
    type: TelemetryType.USAGE,
    usage: usage
  });
}
export function formatError(e) {
  if (isError(e)) {
    var stackTrace = computeStackTrace(e);
    return {
      error: {
        kind: stackTrace.name,
        stack: toStackTraceString(scrubCustomerFrames(stackTrace))
      },
      message: stackTrace.message
    };
  }
  return {
    error: {
      stack: NO_ERROR_STACK_PRESENT_MESSAGE
    },
    message: "Uncaught" /* NonErrorPrefix.UNCAUGHT */.concat(" ", jsonStringify(e))
  };
}
export function scrubCustomerFrames(stackTrace) {
  stackTrace.stack = stackTrace.stack.filter(function (frame) {
    return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) {
      return frame.url.startsWith(allowedFrameUrl);
    });
  });
  return stackTrace;
}